import {Component, OnInit } from '@angular/core';
import {DataManipulationService} from "../../services/data-manipulation.service";
import {ApiwrapperService} from "../../services/apiwrapper.service";
import { Router } from '@angular/router';

type SortDirection = 'ASC' | 'DESC';
interface SortState {
  category: string;
  direction: SortDirection;
}

@Component({
  selector: 'app-codex',
  templateUrl: './codex.component.html',
  styleUrls: ['./codex.component.scss']
})
export class CodexComponent implements OnInit {

  public index: number = 0
  knobProgress: number = 0;

  indicator = {
    helpful: '../../../assets/icons/codex/be-present-&-helpful.svg',
    direction: '../../../assets/icons/codex/set-a-clear-direction.svg',
    empower: '../../../assets/icons/codex/empower-people.svg',
    inspirational: '../../../assets/icons/codex/be-inspirational.svg',
    transparent: '../../../assets/icons/codex/be-transparent.svg',
  };

  fade = {
    green: '#DBF1EA',
    yellow: '#F3EEC7',
    orange: '#FFE7C8',
    red: '#FEE5E5',
  }
  teams: any = {
    current: [],
    previous: [],
  };
  questions: any = {
    current: [],
    previous: [],
  };

  codexReports: any;
  codex: any = {
    showCodex: false,
    current: {},
    previous: {},
    selector: [],
    hasPrevious: true,
  };
  activeMenuCategory: any;
  activeSort: SortState | null = null;
  reportIndex: number = 0;
  teamCodexBody: any = {};

  constructor(public data: DataManipulationService, private api: ApiwrapperService, private router: Router) {
    this.getColors();
    this.data.showLoading();
  }

  knobColor: string = this.data.colors.green;
  tab: number = 0;

  colorInterval = {
    "red": {"min": 0, "max": 39},
    "orange": {"min": 40, "max": 59},
    "yellow": {"min": 60, "max": 79},
    "green": {"min": 80, "max": 100}
  };

  codexIndicatorBackground: { [key: string]: string } = {
    'empower-people': this.data.colors.greyGradient,
    'be-present-&-helpful': this.data.colors.greyGradient,
    'be-transparent': this.data.colors.greyGradient,
    'be-inspirational': this.data.colors.greyGradient,
    'set-a-clear-direction': this.data.colors.greyGradient,
  }

  ngOnInit(): void {

  }

  openSortMenu(category: string) {
    if (this.activeMenuCategory === category) {
      this.activeMenuCategory = null;
    } else {
      if (category === 'statement-score') {
        this.activeSort = {
          category,
          direction: 'DESC'
        };
      }
      this.activeMenuCategory = category;
    }
  }

  toggleSort(category: string, direction: SortDirection) {
    if (this.activeSort && this.activeSort.category === category && this.activeSort.direction === direction) {
      this.activeSort = null;
    } else {
      this.activeSort = { category, direction };
    }
    
    if (category !== 'statement-score') {
      const body: any = {};

      if (this.activeSort) {
        const { category, direction } = this.activeSort;
        if (category === 'average_score') {
          body.scoreOrder = direction;
        } else if (category === 'development') {
          body.progressOrder = direction;
        } else {
          const uuid = this.codex.current.mappedBySlug[category]?.category?.uuid;
          if (uuid) {
            body.categoryUuid = uuid;
            body.categoryOrder = direction;
          }
        }
      }
      this.teamCodexBody = body;
      this.sortReports(this.reportIndex);
    } else if (category === 'statement-score' && this.activeSort) {
      this.getStatements(this.codex.current.uuid, direction);
    } else {
      this.getStatements(this.codex.current.uuid, '');
    }
  }

  isChecked(category: string, direction: SortDirection): boolean {
    return (this.activeSort?.category === category && this.activeSort?.direction === direction);
  }

  hasActiveSort(category: string): boolean {
    return (this.activeSort?.category === category);
  }

  getColors() {
    this.api.getIndicatorInterval().subscribe(
      res => {
        //@ts-ignore
        res.forEach(el => {
          // @ts-ignore
          this.colorInterval[el.indicatorColor.color].min = el.min;
          // @ts-ignore
          this.colorInterval[el.indicatorColor.color].max = el.max;
        });
        this.getCodex();
      }
    );
  }

  setKnobProgressBar(score: number) {
    if (document.getElementById("svgProgress")) {
      this.knobProgress = Math.round((184 - (184 * score) / 100));
      //@ts-ignore
      document.getElementById("svgProgress").style.strokeDashoffset = this.knobProgress.toString();
    } else {
      setTimeout(() => {
        this.setKnobProgressBar(score)
      }, 200);
    }
  }

  private getCodex() {
    this.api.getCodex().subscribe((res: any) => {
      // set the current codex and the previous one
      let reports = res._embedded.reports.sort((a: any, b:any) => new Date(b.startDate.date).getTime() - new Date(a.startDate.date).getTime());
      if (reports.length === 0) {
        this.data.hideLoading();
      }
      this.codexReports = reports;
      reports.forEach((report: any, index: number) => {
        this.codex.selector.push({
          label: report.label,
          index
        })
      })
      this.sortReports(this.reportIndex);
    })
  }

  sortReports(i: number) {
    this.reportIndex = i;
    if (this.codexReports.length > 0) {
      this.codexReports[i].topics = [...this.codexReports[i].topics].sort((a, b) => b.score - a.score)
      this.codexReports[i].mappedTopics = this.mapTopicsByCategory(this.codexReports[i].topics);
      this.codexReports[i].mappedBySlug = this.mapTopicsByCatSlug(this.codexReports[i].topics);
      this.codex.current = this.codexReports[i];
      if (this.codexReports[i + 1]) {
        this.codexReports[i + 1].topics = [...this.codexReports[i + 1].topics].sort((a, b) => b.score - a.score)
        this.codexReports[i + 1].mappedTopics = this.mapTopicsByCategory(this.codexReports[i + 1].topics);
        this.codexReports[i + 1].mappedBySlug = this.mapTopicsByCatSlug(this.codexReports[i + 1].topics);
        this.codex.previous = this.codexReports[i + 1];
        this.codex.hasPrevious = true;
      } else {
        this.codex.hasPrevious = false;
      }

      this.codex.current.topics.forEach((el: any) => {
        Object.keys(this.colorInterval).forEach((color: any) => {
          // @ts-ignore
          const interval = this.colorInterval[color];
          if (this.codex.current.score >= interval.min && this.codex.current.score <= interval.max) {
            // @ts-ignore
            this.knobColor = this.data.colors['' + color];
          }
          if (el.score >= interval.min && el.score <= interval.max) {
            // @ts-ignore
            this.codexIndicatorBackground['' + el.category.slug] = this.data.colors[color + 'Gradient'].toString();
          } else if (el.score === 0) {
            // @ts-ignore
            this.codexIndicatorBackground['' + el.category.slug] = this.data.colors['greyGradient'].toString();
          }
        });
      });
      this.codex.showCodex = true;
      this.data.hideLoading();
      this.getTeams(i, this.teamCodexBody);
      this.getStatements(this.codex.current.uuid, '');
    }
  }


  mapTopicsByCategory = (topics: any[]) => {
    return topics.reduce((acc: any, topic: any) => {
      const uuid = topic.category?.uuid;
      if (!uuid) return acc;
      acc[uuid] = topic;
      return acc;
    }, {});
  };

  mapTopicsByCatSlug = (topics: any[]) => {
    return topics.reduce((acc: any, topic: any) => {
      const uuid = topic.category?.slug;
      if (!uuid) return acc;
      acc[uuid] = topic;
      return acc;
    }, {});
  };
  mapByUuid = (teams: any[]) => {
    return teams.reduce((acc: any, team: any) => {
      const uuid = team.team.uuid;
      if (!uuid) return acc;
      acc[uuid] = team;
      return acc;
    }, {});
  };

  mapByName = (statements: any[]) => {
    return statements.reduce((acc: any, statement: any) => {
      statement.title = statement.title.replace(/[^a-zA-Z0-9]/g, '-').toLowerCase();
      const uuid = statement.title;
      if (!uuid) return acc;
      acc[uuid] = statement;
      return acc;
    }, {});
  };


  getColor(score: any, gradient: boolean) {
    let colorReturn;
    Object.keys(this.colorInterval).forEach((color: any) => {
      // @ts-ignore
      const interval = this.colorInterval[color];
      if (score >= interval.min && score <= interval.max) {
        // @ts-ignore
        colorReturn = !gradient ? this.fade[color] : this.data.colors[color].toString();
        // colorReturn = !gradient ? this.fade[color] : this.data.colors[color + 'Gradient'].toString();
      } else if (score === 0) {
        // @ts-ignore
        colorReturn =  '#DEE4F3';
      }
    })
    return colorReturn;
  }

  diffPercent(newValue: number, oldValue: number): string {
    const diff = newValue - oldValue;
    const percent = Math.abs(diff).toFixed(0); // round to whole %
    if (diff > 0) {
      return `${percent}`;
    } else if (diff < 0) {
      return `-${percent}`;
    } else {
      return `0`;
    }
  }


  private getTeams(index: number, teamCodexBody: any) {
    // get the teams tab
    this.api.getTeamsCodex(this.codexReports[index].uuid, teamCodexBody).subscribe((res: any) => {
      let teams = res._embedded.reports;
      teams.forEach((team: any) => {
        team.details.forEach((detail: any) => {
          detail.color = this.getColor(detail.score, false);
        })
        team.slug = this.mapTopicsByCatSlug(team.details)
        team.categ = this.mapTopicsByCategory(team.details)
      })
      this.teams.current = teams;
    })

    this.teams.previous = [];
    if (this.codexReports[index + 1]) {
      this.api.getTeamsCodex(this.codexReports[index+1].uuid, teamCodexBody).subscribe((res: any) => {
        let teams = res._embedded.reports;
        teams.forEach((team: any) => {
          team.slug = this.mapTopicsByCatSlug(team.details)
          team.categ = this.mapTopicsByCategory(team.details)
        })
        this.teams.previous = this.mapByUuid(teams);
      });
    }
  }

  private getStatements(uuid: string, sortingParam: string) {
    // get the statement tab
    this.api.getQuestionsCodex(uuid, sortingParam).subscribe((res: any) => {
      let statements = res._embedded.reports;
      statements.forEach((statement: any) => {
        const maxScore = Math.max(...statement.details.map((i:any) => i.percentage));
        statement.details.forEach( (i: any) => {
          i.color = i.percentage === maxScore;
        });
        statement.mapped = this.mapByName(statement.details);
      });
      this.questions.current = statements.map((statement: any) => ({
        ...statement,
        iconColorGradient: this.getStatementsColor(statement.score)
      }));
    });
  }

  getStatementsColor(statementScore: any) {
    if (statementScore === 0) {
      return this.data.colors['greyGradient'].toString();
    }
    
    const match = Object.entries(this.colorInterval).find(
      ([_, interval]: any) =>
        statementScore >= interval.min && statementScore <= interval.max
    );
    //@ts-ignore
    return match ? this.data.colors[`${match[0]}Gradient`].toString() : this.data.colors['greyGradient'].toString();
  }

  goBack() {
    this.router.navigate(['/workspace-overview']);
  }
}
